import { getRequest, postRequest, deleteRequest, patchFileRequest } from "../helpers/fetchHandler"
import {
  ACTIVITIES_LOADING,
  ACTIVITIES_SUCCESS,
  ACTIVITIES_FAILED,
  ACTIVITY_SELECTED,
  ACTIVITY_UNSELECTED,
  SUBCATEGORIES_LOADING,
  SUBCATEGORIES_SUCCESS,
  SUBCATEGORIES_FAILED,
  CREATE_ACTIVITIES_LOADING,
  CREATE_ACTIVITIES_SUCCESS,
  CREATE_ACTIVITIES_FAILED,
  UPDATE_ACTIVITIES_LOADING,
  UPDATE_ACTIVITIES_SUCCESS,
  UPDATE_ACTIVITIES_FAILED,
  DELETE_ACTIVITIES_LOADING,
  DELETE_ACTIVITIES_SUCCESS,
  DELETE_ACTIVITIES_FAILED,
} from "../constants/actionTypes"

export function fetchActivities() {
  return async dispatch => {
    dispatch({ type: ACTIVITIES_LOADING })

    const url = "/api/v1/activities"
    try {
      const response = await getRequest({ url, auth: true })
      dispatch({ type: ACTIVITIES_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: ACTIVITIES_FAILED, error })
      throw error
    }
  }
}

export function fetchActivityCategories() {
  return async dispatch => {
    dispatch({ type: SUBCATEGORIES_LOADING })

    const url = "/api/v1/activities/subcategories"
    try {
      const response = await getRequest({ url, auth: true })
      dispatch({ type: SUBCATEGORIES_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: SUBCATEGORIES_FAILED, error })
      throw error
    }
  }
}

export function createActivity(data) {
  return async dispatch => {
    dispatch({ type: CREATE_ACTIVITIES_LOADING })

    const url = "/api/v1/activities"
    try {
      const response = await postRequest({ url, data, auth: true })
      dispatch({ type: CREATE_ACTIVITIES_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: CREATE_ACTIVITIES_FAILED, error })
      throw error
    }
  }
}

export function updateActivity(id, data) {
  return async dispatch => {
    dispatch({ type: UPDATE_ACTIVITIES_LOADING })

    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => {
      if (value == null) {
        return
      } else if (key === "image") {
        formData.append(key, value, value.name)
      } else if (key === "categories") {
        const categories = Array.isArray(value) ? value : [value]
        categories.forEach(categoryId => formData.append(`${key}[]`, categoryId))
      } else {
        formData.append(key, value)
      }
    })

    const url = `/api/v1/activities/${id}`
    try {
      const response = await patchFileRequest({ url, data: formData, auth: true })
      dispatch({ type: UPDATE_ACTIVITIES_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: UPDATE_ACTIVITIES_FAILED, error })
      throw error
    }
  }
}

export function deleteActivity(id) {
  return async dispatch => {
    dispatch({ type: DELETE_ACTIVITIES_LOADING })

    const url = `/api/v1/activities/${id}`
    try {
      await deleteRequest({ url, auth: true })
      dispatch({ type: DELETE_ACTIVITIES_SUCCESS, payload: id })
    } catch (error) {
      dispatch({ type: DELETE_ACTIVITIES_FAILED, error })
      throw error
    }
  }
}

export function selectActivity(id) {
  return dispatch => {
    dispatch({ type: ACTIVITY_SELECTED, payload: id })
    return Promise.resolve()
  }
}

export function unselectActivity() {
  return dispatch => {
    dispatch({ type: ACTIVITY_UNSELECTED })
    return Promise.resolve()
  }
}
